import { type QueryClient } from '@tanstack/react-query';
import { type AnyRedirect, createRootRouteWithContext } from '@tanstack/react-router';
import { z } from 'zod';

import AppWrapper from '@@containers/App/AppWrapper';
import ModalProvider from '@@containers/Modal/useModal/ModalProvider';
import NavPrompt from '@@router/components/NavPrompt';
import { useReloadOnContentLanguageChange } from '@@router/useReloadOnContentLanguageChange';
import { useRerunGuardsOnAuthChange } from '@@router/useRerunGuardsOnAuthChange';

export type RouterContext = {
    queryClient: QueryClient;
    /** Where the authentication guard sends signed out users. Tests replace it to stay in the app. */
    getLoginRedirect: () => Promise<AnyRedirect>;
};

// The search params any page can have
const rootSearchParams = z.object({
    shortcuts: z.literal(true).optional().catch(undefined),
});

const RootLayout = () => {
    useRerunGuardsOnAuthChange();
    useReloadOnContentLanguageChange();

    return (
        // `ModalProvider` needs to be a child of the router since some modals use hooks which depend on it
        <ModalProvider>
            <>
                <AppWrapper />
                <NavPrompt />
            </>
        </ModalProvider>
    );
};

export const Route = createRootRouteWithContext<RouterContext>()({
    validateSearch: rootSearchParams,
    component: RootLayout,
});
